import { Container } from '@hg/stylizator/components'
import { Text } from '@hg/stylizator/typography'
import { desktop, Spacing } from '@hg/stylizator/utils'
import * as React from 'react'
import styled, { useTheme } from 'styled-components'

import { useTranslation } from 'app/hooks/use-translation'
import Chevron from 'app/icons/Chevron'

const BackToBlog: React.FC = () => {
  const theme = useTheme()
  const t = useTranslation()

  return (
    <Background>
      <Container
        margins={{
          mobile: 0,
          tablet: 0,
          desktop: 0,
          largeDesktop: 0,
        }}
        style={{ padding: '0 16px', boxSizing: 'border-box' }}
      >
        <Link href="/blog">
          <Spacing right>
            <Chevron color={theme.color.blue[60]} width={24} height={24} />
          </Spacing>
          <Text type="label" color={theme.color.blue[60]}>
            <span>{t('back_to_blog')}</span>
          </Text>
        </Link>
      </Container>
    </Background>
  )
}

export default BackToBlog

const Background = styled.div`
  padding: 16px 0;
  background: ${(props) => props.theme.color.blue[10]};

  @media ${desktop} {
    padding: 24px 0px;
  }
`

const Link = styled.a`
  display: inline-flex;
  padding: 4px 8px;
`
